export default "__VITE_ASSET__49HLEVozYLwea3croYnksw__";